















































































import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import { CombinedVueInstance } from "vue/types/vue";
import { getData, Feature } from "@/api/api";
import Result from "./components/Result.vue";

export default {
  components: {
    Result,
  },
  data() {
    return {
      pharmacyData: null,
      isInit: false,
      inputText: "",
      singlePharmacyData: null,
      isLoading: false,
    };
  },
  methods: {
    async getPharmacyData() {
      const { features } = await getData();
      this.pharmacyData = features;
    },
    getFilterData() {
      this.isLoading = true;

      const data = this.pharmacyData.find(
        (pharmacy) => pharmacy.properties.id === this.inputText
      );
      this.isLoading = false;

      this.singlePharmacyData = data ? data : "查無醫事機構資料";

      if (this.inputText !== this.$route.params.id) {
        this.updateRoute(this.inputText);
      }
    },
    resetData() {
      this.inputText = "";
      this.singlePharmacyData = null;
      this.updateRoute(this.inputText);
    },
    updateRoute(id) {
      this.$router.push(`/${id}`);
    },
  },
  computed: {
    lastUpdate() {
      if (!this.pharmacyData) return "";
      return this.pharmacyData.find(
        (pharmacy) => pharmacy.properties.updated.length > 0
      )!.properties.updated;
    },
    currentPath() {
      return window.location.href;
    },
  },
  async created() {
    await this.getPharmacyData();
    console.log("Last update:", this.lastUpdate);
    this.isInit = true;
  },
  mounted() {
    window.setInterval(() => {
      this.getPharmacyData();
      console.log("Last update:", this.lastUpdate);
    }, 60000);

    this.$alert("本網站已暫停維護，查詢資料之結果僅供參考", "", {
      confirmButtonText: "確定",
      type: "warning",
      showClose: false,
      callback: (action) =>
        this.$message({
          message: "本網站已暫停維護，查詢資料之結果僅供參考",
          type: "warning",
          duration: 0,
        }),
    });
  },
  watch: {
    pharmacyData() {
      if (this.singlePharmacyData === null) return;
      this.getFilterData();
    },
    isInit(val) {
      if (val && this.$route.params.id) {
        this.inputText = this.$route.params.id;
        this.getFilterData();
      }
    },
  },
} as ComponentOption;

export type ComponentOption = ThisTypedComponentOptionsWithRecordProps<
  Instance,
  Data,
  Methods,
  Computed,
  Props
>;

export type ComponentInstance = CombinedVueInstance<
  Instance,
  Data,
  Methods,
  Computed,
  Props
>;

export interface Instance extends Vue {}

export interface Data {
  pharmacyData: Feature[];
  isInit: boolean;
  inputText: string;
  singlePharmacyData: Feature | string | null;
  isLoading: boolean;
}

export interface Methods {
  getPharmacyData: () => void;
  getFilterData: () => void;
  resetData: () => void;
  updateRoute: (id: string) => void;
}

export interface Computed {
  lastUpdate: string;
  currentPath: string;
}

export interface Props {}
